<template>
<div class="update-associated-cohort-leaps-challenge">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" v-on:click="closeCurrentOverlay()">
                    <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Cohort:
                </div>
                <div class="col-md-4 col-lg-4 text-align-left">
                  <div class="form-group margin-bottom-0Perc">
                    <b>{{selectedCohortObj.CohortName}}</b>
                  </div>
                </div>
                <div class="col-md-5 col-lg-5"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  LEAPS Goal(s):
                </div>
                <div class="col-md-8 col-lg-8">
                  <div class="form-group">
                    <div class="text-align-left">
                      <!-- <input type="checkbox" v-model="selectAllSelectedValue" >&nbsp;&nbsp;&nbsp; Select All -->
                    </div>
                    <div class="text-align-left" v-for="(leapsChallengeObj, index) in leapsChallengesListValue" :key="index + leapsChallengeObj.ChallengeLibraryId" v-if="checkForVisibility(leapsChallengeObj)">
                      <!-- <input type="checkbox" v-model="associatedCohortChallengeArrValue" :value="leapsChallengeObj.ChallengeLibraryId"> &nbsp;&nbsp;&nbsp; {{(index + 1)}}. {{leapsChallengeObj.ChallengeTitle}}-->
                      - {{leapsChallengeObj.ChallengeTitle}}   
                      <div class="margin-left-4Perc text-color-orange" v-for="(leapsAttachedActionObj, actionIndex) in JSON.parse(leapsChallengeObj.ListOfActions)" :key="actionIndex + leapsAttachedActionObj.ActionLibraryId + leapsChallengeObj.ChallengeLibraryId">
                        <input type="checkbox" v-model="leapsAttachedActionObj.IsChecked" @click="performUserClickAction($event, 'clicked_action', leapsChallengeObj, leapsAttachedActionObj)">&nbsp;&nbsp;&nbsp; {{leapsAttachedActionObj.ActionName}}
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateCohortLeapsChallenges">Update</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <loader></loader>
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import { cohortService } from '@/server-util/cohort-service'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import { leapsChallengesService } from '@/server-util/leaps-challenges-service'
import { forEach, findIndex, filter, find } from 'lodash'
export default {
  props: ['serverResp', 'selectedCohortObj'],
  created: function () {
    this.getGroupList()
    this.getLeapsChallengesList()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      associatedCohortChallengeArr: [],
      associatedCohortActionArr: [],
      isLeapsChallengeUpdatedSuccessfully: false,
      createObj: null,
      selectAllSelected: false
    }
  },
  name: 'update-associated-cohort-leaps-challenge',
  methods: {
    checkForVisibility: function (challengeObj) {
      const foundChallengeObj = find(this.serverResp, (obj) => {
        return obj.ChallengeID === challengeObj.ChallengeLibraryId
      })
      return (foundChallengeObj !== undefined && foundChallengeObj !== 'undefined' && foundChallengeObj !== null && foundChallengeObj !== 'null' && foundChallengeObj !== '')
    },
    performUserClickAction: function (event, operationName, leapsChallengeObj, leapsAttachedActionObj) {
      switch (operationName) {
        case 'clicked_action':
          const foundChallengeIndex = findIndex(this.$store.state.leapsChallengesList, (challengeObj) => {
            return leapsChallengeObj.ChallengeLibraryId === challengeObj.ChallengeLibraryId
          })
          if (foundChallengeIndex > -1) {
            const associatedActions = JSON.parse(this.$store.state.leapsChallengesList[foundChallengeIndex].ListOfActions)
            if (associatedActions.length > 0) {
              const foundActionIndex = findIndex(associatedActions, (actionObj) => {
                return leapsAttachedActionObj.ActionLibraryId === actionObj.ActionLibraryId
              })
              if (foundActionIndex > -1) {
                associatedActions[foundActionIndex].IsChecked = !associatedActions[foundActionIndex].IsChecked
                this.$store.state.leapsChallengesList[foundChallengeIndex].ListOfActions = JSON.stringify(associatedActions)
              }
            }
          }
          break
      }
    },
    setDefaultValues: function () {
      for (var i = 0; i < this.$store.state.leapsChallengesList.length; i++) {
        const foundChallengeIndex = findIndex(this.serverResp, (obj) => {
          return this.$store.state.leapsChallengesList[i].ChallengeLibraryId === obj.ChallengeID
        })
        if (foundChallengeIndex > -1) {
          const listOfActions = JSON.parse(this.$store.state.leapsChallengesList[i].ListOfActions)
          if (listOfActions.length > 0) {
            for (var j = 0; j < listOfActions.length; j++) {
              listOfActions[j].IsChecked = false
              for (var k = 0; k < this.serverResp[foundChallengeIndex].ChallengeActionsData.length; k++) {
                if (listOfActions[j].ActionLibraryId === this.serverResp[foundChallengeIndex].ChallengeActionsData[k].ActionID) {
                  listOfActions[j].IsChecked = true
                  break
                }
              }
            }
            this.$store.state.leapsChallengesList[i].ListOfActions = JSON.stringify(listOfActions)
          }
        }
      }
    },
    closeCurrentOverlay: function () {
      var objToReturn = {
        operationName: 'close_overlay'
      }
      this.$emit('updateValues', objToReturn)
    },
    resetValuesToDefault: function () {
      this.associatedCohortChallengeArr = []
    },
    getCurrentServerSideStoredChallengeObj: function (challengeObj) {
      const foundObj = find(this.serverResp, (currChallengeObj) => {
        return challengeObj.ChallengeLibraryId === currChallengeObj.ChallengeID
      })
      return foundObj
    },
    getAvailableChallengeActionsId: function (serverSideStoredChallengeObj, actionObj) {
      const foundObj = find(serverSideStoredChallengeObj.ChallengeActionsData, (currChallengeActionObj) => {
        return actionObj.ActionLibraryId === currChallengeActionObj.ActionID
      })
      return (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') ? foundObj.AvailableChallengeActionsId : null
    },
    getSelectedChallengeAction: function () {
      var arrToReturn = []
      forEach(this.$store.state.leapsChallengesList, (challengeObj) => {
        const selectedActionCount = filter(JSON.parse(challengeObj.ListOfActions), (actionObj) => {
          return actionObj.IsChecked
        }).length
        if (selectedActionCount > 0) {
          const serverSideStoredChallengeObj = this.getCurrentServerSideStoredChallengeObj(challengeObj)
          var objToPush = {
            AvailableCohortChallengesId: serverSideStoredChallengeObj.AvailableCohortChallengesId,
            ChallengeID: challengeObj.ChallengeLibraryId,
            ChallengeActionsData: []
          }
          forEach(JSON.parse(challengeObj.ListOfActions), (actionObj) => {
            if (actionObj.IsChecked) {
              var actionObjToPush = {
                AvailableChallengeActionsId: this.getAvailableChallengeActionsId(serverSideStoredChallengeObj, actionObj),
                ActionID: actionObj.ActionLibraryId
              }
              objToPush.ChallengeActionsData.push(actionObjToPush)
            }
          })
          objToPush.ChallengeActionsData = objToPush.ChallengeActionsData
          arrToReturn.push(objToPush)
        }
      })
      return arrToReturn
    },
    updateCohortLeapsChallenges: function () {
      var storeObj = this.$store
      const objToPost = this.getSelectedChallengeAction()
      console.log(JSON.stringify(objToPost))
      if (this.validateRequiredFieldBeforeSubmit(objToPost)) {
        if (
          storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
        ) {
          this.$store.state.isLoading = true
          cohortService
            .updateAssociateCohortWithLeapsChallenges(
              storeObj.state.access_token,
              objToPost
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.isLeapsChallengeUpdatedSuccessfully = true
                this.showAlertDialog = true
                this.errorMsg = '\'' + this.selectedCohortObj.CohortName + '\' successfully updated with selected goal(s) and action(s).'
                this.$store.state.isLoading = false
              } else {
                // AK: Hide Spinner
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined UPDATING ASSCOIATED COHORT WITH LEAPS ACTION.'
          )
        }
      }
    },
    getIsCheckedFlagValue: function (challengeObj, actionObj) {
      var valueToReturn = false
      const foundChallengeObj = find(this.serverResp, (obj) => {
        return obj.ChallengeID === challengeObj.ChallengeLibraryId
      })
      if (foundChallengeObj !== undefined && foundChallengeObj !== 'undefined' && foundChallengeObj !== null && foundChallengeObj !== 'null' && foundChallengeObj !== '') {
        const challengeActionsData = foundChallengeObj.ChallengeActionsData
        const foundChallengeActionObj = find(challengeActionsData, (currActionObj) => {
          return currActionObj.ActionID === actionObj.ActionLibraryId
        })
        valueToReturn = (foundChallengeActionObj !== undefined && foundChallengeActionObj !== 'undefined' && foundChallengeActionObj !== null && foundChallengeActionObj !== 'null' && foundChallengeActionObj !== '')
      }
      return valueToReturn
    },
    getLeapsChallengesList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        this.$store.state.isLoading = true
        leapsChallengesService
          .getLeapsChallengeList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.$store.state.leapsChallengesList = responseObj.data
              this.setDefaultValues()
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS CHALLEGNE LIST'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.isLeapsChallengeUpdatedSuccessfully) {
        this.closeCurrentOverlay()
        this.isLeapsChallengeUpdatedSuccessfully = false
        this.resetValuesToDefault()
      }
    },
    getGroupList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          this.$store.state.isLoading = true
        }
        groupService
          .listGroups(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING GROUP LIST'
        )
      }
    },
    isJson: function (strToCheck) {
      var valueToReturn = false
      strToCheck = (typeof strToCheck !== 'string') ? JSON.stringify(strToCheck) : strToCheck
      try {
        strToCheck = JSON.parse(strToCheck)
      } catch (e) {
        valueToReturn = false
      }
      if (typeof strToCheck === 'object' && strToCheck !== null) {
        valueToReturn = true
      }
      return valueToReturn
    },
    validateRequiredFieldBeforeSubmit: function (objToPost) {
      if (this.currSelectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group.'
        return false
      } else if (this.selectedCohortObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a cohort.'
        return false
      } else if (!this.hasSelectedAtleastOneAction(objToPost)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one LEAPS Goal to associate with \'' + this.selectedCohortObj.CohortName + '\' cohort.'
        return false
      }
      return true
    },
    hasSelectedAtleastOneAction: function (objToPost) {
      const filterListLength = filter(objToPost, (obj) => {
        return obj.ChallengeActionsData.length > 0
      }).length
      return filterListLength > 0
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getSelectedCohortObj: {
      get: function () {
        return this.selectedCohortObj
      },
      set: function (newValue) {
        this.selectedCohortObj = newValue
      }
    },
    getGroupListValue: {
      get: function () {
        return this.$store.state.groupList
      }
    },
    leapsChallengesListValue: {
      get: function () {
        return this.$store.state.leapsChallengesList
      },
      set: function (newValue) {
        this.$store.state.leapsChallengesList = newValue
      }
    },
    selectAllSelectedValue: {
      get: function () {
        return this.selectAllSelected
      },
      set: function (newValue) {
        this.selectAllSelected = newValue
        this.associatedCohortChallengeArr = []
        this.associatedCohortActionArr = []
        if (newValue) {
          forEach(this.leapsChallengesListValue, (obj) => {
            this.associatedCohortChallengeArr.push(obj.ChallengeLibraryId)
            const listOfActions = JSON.parse(obj.ListOfActions)
            forEach(listOfActions, (actionObj) => {
              this.associatedCohortActionArr.push(actionObj.ActionLibraryId)
            })
          })
        }
      }
    },
    associatedCohortChallengeArrValue: {
      get: function () {
        return this.associatedCohortChallengeArr
      },
      set: function (newValue) {
        this.associatedCohortChallengeArr = newValue
        this.selectAllSelected = (this.associatedCohortChallengeArr.length === this.leapsChallengesListValue.length)
      }
    },
    associatedCohortActionArrValue: {
      get: function () {
        return this.associatedCohortActionArr
      },
      set: function (newValue) {
        this.associatedCohortActionArr = newValue
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.text-color-orange {
  color: #f39c12;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/group/UpdateAssociatedCohortLeapsChallengeOverlay.vue